export default function translateContractStatus(status) {
    if (status === "confirmed") return "Angenommen";
    else if (status === "cancelled") return "Abgelehnt";
    else if (status === "expired") return "Ausgelaufen";
    else if (status === "submitted") return "Ausstehend";
    else if (status === "revoked") return "Widerrufen";
    else if (status === "customer_checkout") return "Versendet";
    else return "-/-";
}
